import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import MentionsLegales from "@/pages/MentionsLegales";
import CGV from "@/pages/CGV";
import CommentRemplirCFE from "@/pages/CommentRemplirCFE";
import Formulaire1447CSD from "@/pages/Formulaire1447CSD";
import CFEPremiereAnnee from "@/pages/CFEPremiereAnnee";

function App() {
  return (
    <div className="App min-h-screen bg-[#F8FAFC]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/confirmation/:declarationId" element={<ConfirmationPage />} />
          <Route path="/confirmation" element={<ConfirmationPage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/comment-remplir-cfe-auto-entrepreneur" element={<CommentRemplirCFE />} />
          <Route path="/formulaire-1447-c-sd-auto-entrepreneur" element={<Formulaire1447CSD />} />
          <Route path="/cfe-auto-entrepreneur-premiere-annee" element={<CFEPremiereAnnee />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
